import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Alert, Descriptions, Skeleton } from "antd";
import UserType from "../enums/UserType";
import { formatDateTime } from "../../../util/FormatUtil";
import React from "react";
import ChangeSetTable from "./ChangeSetTable";
const ChangeHistoryLog = (props) => {
    const renderUser = (user) => {
        const parts = [user?.firstName, user?.lastName];
        const name = parts.filter(it => !!it).join(" ");
        const userType = (user?.type)
            ? UserType.valueOf(user?.type)
            : null;
        const showUserTypeTag = userType !== UserType.ADMIN;
        return (_jsxs(_Fragment, { children: [name, "\u00A0", showUserTypeTag && userType?.renderTag()] }));
    };
    if (props.loading) {
        return _jsx(Skeleton, { active: true });
    }
    if (!props.changes || props.changes.length == 0) {
        return _jsx(Alert, { type: "warning", title: "No changes were found" });
    }
    return props.changes.map(change => {
        let rowKey = `${change.user?.firstName ?? ''}${change.user?.lastName ?? ''}${change.modifiedAt}`;
        return (_jsx(ChangeSetTable, { style: { marginBottom: 15 }, hidePreviousValue: props.hidePreviousValue, title: () => {
                return (_jsxs(Descriptions, { size: "small", children: [_jsx(Descriptions.Item, { label: "User", children: renderUser(change.user) }), _jsx(Descriptions.Item, { label: "Changed At", children: formatDateTime(change.modifiedAt) })] }));
            }, changes: change.changes }, rowKey));
    });
};
export default ChangeHistoryLog;
